import { calculateCorporateTaxInfo } from "@/helper/corporate_tax_helper";
import { calculatePersonalTaxInfo } from "@/helper/personal_tax_helper";
import { pickBy } from "lodash";

const state = {
  isTaxCharter: false,
  income: {
    onlineSelling: null,
    salary: null,
    charter: null,
  },
  expense: {
    cost: null,
    employeeExpenses: null,
    rent: null,
    electricity: null,
    water: null,
    phone: null,
    shipping: null,
    accounting: null,
    audit: null,
    advertising: null,
  },
  deducts: {
    personal: 60000,
    spouse: null,
    pregnancy: null,
    children: null,
    parents: null,
    handicaps: null,
    houseInterest: null,
    firstHouse: null,
    lifeInsurance: null,
    pensionInsurance: null,
    healthInsurance: null,
    parentHealthInsurance: null,
    sso: null,
    pvd: null,
    ssf: null,
    rmf: null,
    specialDonation: null,
    generalDonation: null,
    partyDonation: null,
  },
};

const getters = {
  getIncome(state) {
    return state.income;
  },
  getTaxCharter(state) {
    return state.isTaxCharter;
  },
  getExpense: (state) => state.expense,
  getCharter: (state) => state.income.charter,
  getFilterExpense: (state) =>
    pickBy(state.expense, (expense) => expense !== null),
  getDeduct: (state) => state.deducts,
  taxExpenseDeductionInfo(state, getters) {
    let totalIncomeOnlineSelling = Number(getters.getIncome.onlineSelling) * 12;
    let totalIncomeSalary = Number(getters.getIncome.salary) * 12;

    const totalExpense = Object.values(getters.getFilterExpense).reduce(
      (sum, value) => sum + parseFloat(value) * 12,
      0
    );

    const taxCharter = calculatePersonalTaxInfo({
      incomes: {
        onlineSelling: {
          income: totalIncomeOnlineSelling,
          expense: totalIncomeOnlineSelling * 0.6,
          isCharter: true,
        },
        salary: {
          income: totalIncomeSalary,
          expense: 0,
        },
      },
      deducts: {},
    });
    const taxReal = calculatePersonalTaxInfo({
      incomes: {
        onlineSelling: {
          income: totalIncomeOnlineSelling,
          expense: totalExpense,
          isCharter: false,
        },
        salary: {
          income: totalIncomeSalary,
          expense: 0,
        },
      },
      deducts: {},
    });
    return {
      charter: taxCharter,
      real: taxReal,
    };
  },
  taxComparationInfo(state, getters) {
    const totalIncomeOnlineSelling =
      Number(getters.getIncome.onlineSelling) * 12;
    const totalIncomeSalary = Number(getters.getIncome.salary) * 12;
    const isCharter = Number(getters.getCharter);

    // const isRegisteredVat = rootState.questions.isRegisteredVat;

    // const goodsType = rootState.questions.goodsType;
    // let cost = 0;
    // if (isRegisteredVat && goodsType) {
    //   cost = getters.getFilterExpense.cost;
    // }

    // const expense = {
    //   ...getters.getFilterExpense,
    //   cost,
    // };

    const totalExpense = Object.values(getters.getFilterExpense).reduce(
      (sum, value) => sum + parseFloat(value) * 12,
      0
    );

    const personal = calculatePersonalTaxInfo({
      incomes: {
        onlineSelling: {
          income: totalIncomeOnlineSelling,
          expense: totalExpense,
          isCharter,
        },
        salary: {
          income: totalIncomeSalary,
          expense: 0,
        },
      },
      deducts: getters.getDeduct,
    });

    const corporation = calculateCorporateTaxInfo({
      incomes: {
        onlineSelling: {
          income: totalIncomeOnlineSelling,
          expense: totalExpense,
        },
        salary: {
          income: totalIncomeSalary,
          expense: 0,
        },
      },
    });

    return {
      personal: personal,
      corporation: corporation,
    };
  },
};

const actions = {
  addIncomeValue(context, obj) {
    context.commit("setIncome", obj);
  },
  addExpenseValue(context, obj) {
    context.commit("setExpense", obj);
  },
  addDeductValue(context, obj) {
    context.commit("setDeduct", obj);
  },
  addTaxCharter(context, obj) {
    context.commit("setTaxCharter", obj);
  },
};

const mutations = {
  setIncome(state, obj) {
    state.income[obj.name] = obj.value;
  },
  setExpense(state, obj) {
    state.expense[obj.name] = obj.value;
  },
  setDeduct(state, obj) {
    state.deducts[obj.name] = obj.value;
  },
  setTaxCharter(state, obj) {
    state.isTaxCharter = obj;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
